<template>
  <div class="ml-dropdown" ref="mlDropdown">
    <div class="ml-dropdown-toggle" @click="toggleDropdown" :class="{ active: isNonDefaultSelected }">
      <i style="margin-top: 2px;" :class="['menu-icon', company_icon(currentCompanyId), 'mr-2']"></i>
      {{ selectedCompanyLabel }}
      <span class="ml-svg-icon text-primary" style="cursor: pointer">
        <inline-svg :src="'/assets/svg/chevron-down.svg'" />
      </span>
    </div>

    <div v-if="isOpen" class="ml-dropdown-menu">
      <input
        type="text"
        v-model="filterText"
        @input="filterCompanies"
        placeholder="Sök förening..."
        class="ml-dropdown-search mb-2"
      />

      <div
        class="ml-company-container"
        v-for="(c, i) in filtered"
        :key="`company-${i}`"
        @click="selectCompany(c)"
        :class="['ml-dropdown-item', { selected: c.company_id === currentCompanyId }]"
      >
        <div v-if="c.parent_name" class="ml-parent-row">
          <span class="ml-parent-level-icon">
            <inline-svg :src="'/assets/svg/Directions.svg'" />
          </span>
          <span class="ml-parent-name">{{ c.parent_name }}</span>
        </div>

        <!-- Company Row: Icon on the left and name on the right -->
        <div class="ml-company-row">
          <i :class="['menu-icon', company_icon(c.company_id), 'mr-2']"></i>
          <span>{{ c.shortname || c.name }}</span>
        </div>

        <!-- Additional Info: Org number or other smaller text below -->
        <div v-if="c.org_number" class="ml-org-number">
          <span>{{ c.org_number }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { setCurrentCompanyId } from '@/core/services/initUserMemlist';

export default {
  name: 'CompanyDropdown',
  data() {
    return {
      isOpen: false,
      filterText: '',
      filtered: [],
      initialized: false
    };
  },
  computed: {
    ...mapGetters(['companies', 'currentCompanyId', 'sid']),
    selectedCompanyLabel() {
      const selected = this.companies.find(c => c.company_id === this.currentCompanyId);
      return selected ? (selected.shortname || selected.name) : 'Välj förening';
    },
    isNonDefaultSelected() {
      return this.companies.length && this.currentCompanyId !== this.companies[0].company_id;
    }
  },
  mounted() {
    this.filtered = this.companies;
    document.addEventListener('click', this.onClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onClickOutside);
  },
  watch: {
    companies(newList) {
      this.filtered = newList;
    }
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    async selectCompany(company) {
      this.isOpen = false;
      const result = await setCurrentCompanyId(company.company_id, this.initialized);
      if (!result) {
        this.$emit('error', 'Kunde inte byta förening');
      } else {
        this.$emit('changed', company);
      }
    },
    filterCompanies() {
      const text = this.filterText.toLowerCase();
      this.filtered = this.companies.filter(c =>
        (c.name || '').toLowerCase().includes(text) ||
        (c.shortname || '').toLowerCase().includes(text) ||
        (c.org_number || '').includes(text)
      );
    },
    company_icon(company_id) {
      return this.sid === company_id ? 'flaticon2-world' : 'flaticon-home-2';
    },
    onClickOutside(e) {
      if (!this.$refs.mlDropdown.contains(e.target)) {
        this.isOpen = false;
      }
    }
  }
};
</script>

<style scoped>
.ml-dropdown {
  position: relative;
  width: 100%;
  max-width: 275px;
}

.ml-dropdown-toggle:hover {
  background-color: #1bc5bd;
  color: white;
}
.menu-icon {
  color: #1bc5bd;
}
.ml-dropdown-toggle {
  padding: 12px 16px;
  border: 1px solid #1bc5bd;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
  line-height: 1.5;
  height: 36px;
  width: 200px;
  white-space: nowrap; /* Prevent text wrapping */
  overflow: hidden; /* Hide overflow */
  text-overflow: ellipsis; /* Show ellipsis for overflowing text */
  color: #1bc5bd;
}
.ml-dropdown-toggle.active {
  border-color: #1bc5bd;
  color: #1bc5bd;
}

.ml-svg-icon {
  font-size: 1rem; /* Adjust size as needed */
  margin-left: 14px;
}
.ml-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 10;
  border: 1px solid #1bc5bd;
  background: white;
  border-radius: 4px;
  margin-top: 4px;
  max-height: 600px;
  overflow-y: auto;
  width: 440px;
  min-width: 275px;
  padding: 12px 16px;
  font-size: 1rem;
}
.ml-dropdown-search {
  width: 100%;
  padding: 8px 12px;
  border: none;
  border-bottom: 1px solid #ccc;
  font-size: 0.9rem;
}
.ml-dropdown-item {
  padding: 12px 16px;
  cursor: pointer;
  transition: background 0.2s;
  display: block;  /* Ensure each item is displayed block-level */
}
.ml-dropdown-item:hover {
  background-color: #f5f5f5;
}
.ml-dropdown-item.selected {
  background-color: #3699ff;
  color: white;
}
.ml-org-number {
  font-size: 0.75rem;
  color: #888;
  margin-left: 24px;
}
.ml-dropdown-item.selected .ml-org-number {
  color: white;
}

.ml-parent-row {
  display: flex;
  align-items: center;
  margin-bottom: -3px;
  margin-left: 28px;
}
.ml-company-row i {
  margin-right: 8px; /* Space between icon and name */
}
.ml-parent-name {
  font-size: 12px;
  color: #888888;
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}
.ml-company-row {
  display: flex;
  align-items: center;
  font-size: 14px;
}

.ml-parent-level-icon {
  margin-right: 6px;
  font-size: 0.6rem; /* Adjust icon size */
  color: #3699ff; /* Adjust icon color */
}
.ml-company-container {
  border: 1px solid #dedede;
  border-radius: 3px;
  margin-bottom: 4px;
}
</style>
